import axios from "axios";
import { Message } from "@arco-design/web-react";

let openingLoginDialog = false;

async function openLoginDialogSafely(): Promise<void> {
    if (openingLoginDialog) return;
    openingLoginDialog = true;
    try {
        const { openLoginDialog } = await import("@/dialog");
        await openLoginDialog();
    } finally {
        window.setTimeout(() => {
            openingLoginDialog = false;
        }, 300);
    }
}

const APP_LATEST_FIXED_TOKEN = "asdasdahoinnsdkfsodifh";

function isAppLatestRequest(url: string | undefined): boolean {
    if (!url) return false;
    return url.includes("/app/latest") || url.endsWith("app/latest");
}

const instance = axios.create({
    baseURL: '/api_client/',
    timeout: 60000,
});

instance.interceptors.request.use((config) => {
    if (isAppLatestRequest(config.url)) {
        config.headers.Authorization = `Bearer ${APP_LATEST_FIXED_TOKEN}`;
        return config;
    }
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

/** 接口约定：status 为 "0000" 表示成功，其他为业务错误 */
interface ApiResponse<T = unknown> {
    status: string;
    message?: string;
    data?: T;
}

instance.interceptors.response.use(
    (res) => {
        const data = res.data as ApiResponse;
        if (data?.status !== "0000") {
            // 支付轮询等场景会把 4000 作为“处理中”返回，这里不按全局错误处理
            if (data?.status === "4000") {
                return res.data;
            }
            if (data?.status === "4001") {
                localStorage.removeItem("token");
                void openLoginDialogSafely();
                return Promise.reject(new Error(data?.message ?? "请先登录"));
            }
            const msg = data?.message ?? "请求失败";
            Message.error(msg);
            return Promise.reject(new Error(msg));
        }
        return res.data;
    },
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem("token");
            void openLoginDialogSafely();
        }
        return Promise.reject(err);
    }
);

export default instance;
